import { useState, useEffect, useRef, Fragment, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./EditPotListAction.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import PotItem from "./../../pages/Tab0/PotItem";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { TextField } from "@mui/material";
import apiManager from '../../ApiManager';
import * as YStyled from "../../Styleds";
import { GameContext } from "../../GameContext";
const EditPotListAction = ({setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [selPot, set_selPot] = useState([]);
    const name = useRef(arg.folder.pocket_lists_name);
    const [editting, set_editting] = useState(false);
    const { pocketlist,updatePocketlist } = useContext(GameContext);
    useEffect(() => {
        console.log("EditPotListAction", arg.folder.pocket_lists_id);
        setInProp(true);
        return () => {
            if(name.current!==arg.folder.pocket_lists_name)
            {
                apiManager.fetchPut(`pocket-list/${arg.folder.pocket_lists_id}`, { pocket_lists_name: name.current }).then(res => {
                    updatePocketlist("updateListName",arg.folder.pocket_lists_id,name.current);
                })
            }
        }
    }, [])

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "EditPotListAction"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.header}>
                                    <IconButton className={styleUi.back} onClick={e => {
                                        //set_preLeave(true)
                                        setInProp(false)
                                    }}>
                                        <img src="./assets/ui/leftArrow.svg" />
                                    </IconButton>
                                </div>
                                <YStyled.Label style={{width:"-webkit-fill-available",padding:".4rem 1rem",boxSizing:"border-box",margin:"1rem",border:"1px solid #00000050",background:"transparent"}} >
                                    <YStyled.Col>
                                        <YStyled.Span size={11}>清單名稱</YStyled.Span>
                                        <YStyled.Input size={17} maxLength={30}  defaultValue={arg.folder.pocket_lists_name} onChange={e=>{
                                            name.current=e.target.value;
                                        }}></YStyled.Input>
                                    </YStyled.Col>
                                </YStyled.Label>
                                <div className={styleUi.hr}></div>
                                <div className={styleUi.selLabel}>
                                    <span onClick={e => {
                                        if (editting === true)
                                            set_selPot([])
                                        set_editting(!editting);
                                    }}>{(editting === false) ? "選擇" : "取消"}</span>
                                </div>
                                <div className={styleUi.list}>
                                    {arg.folder.items.map((v, k) => {
                                        return <div>
                                            <div className={styleUi.item}>
                                                <PotItem data={v} />
                                                {editting &&
                                                    <>
                                                        {(selPot.includes(v) === false) ?
                                                            <img src="./assets/ui/radio.png" onClick={e => {
                                                                set_selPot(props => [...props, v])
                                                            }} />
                                                            :
                                                            <img src="./assets/ui/radioSel_b.png" onClick={e => {
                                                                set_selPot(props => props.filter(_v => _v !== v))
                                                            }} />
                                                        }
                                                    </>
                                                }
                                            </div>
                                            {k !== arg.folder.items.length - 1 &&
                                                <div className={styleUi.hr}></div>
                                            }
                                        </div>
                                    })}
                                </div>
                                {editting &&
                                    <div className={styleUi.action} >
                                        <button disabled={selPot.length === 0} className={allStyle.btnGray4} onClick={e => {
                                            addModalType({
                                                cls: "AlertCustom", arg: {
                                                    title: "刪除野放點？",
                                                    desc: "從清單中刪除野放點。",
                                                    options: [
                                                        {
                                                            label: "刪除", cb: () => {
                                                                updatePocketlist("removeListItem",arg.folder.pocket_lists_id,selPot);
                                                                selPot.forEach(v => {
                                                                    apiManager.fetchDelete(`pocket-list/${arg.folder.pocket_lists_id}/items/${v.pocket_list_items_id}`, {});
                                                                })
                                                            }
                                                        },
                                                        {
                                                            label: "取消", cb: () => {

                                                            }
                                                        },
                                                    ],
                                                }
                                            })
                                        }}>
                                            刪除
                                        </button>
                                        <button disabled={selPot.length === 0} className={allStyle.btnGray4} onClick={e => {
                                            addModalType({
                                                cls: "SelFolder", arg: {
                                                    title:"移動至",
                                                    folderId:[arg.folder.pocket_lists_id],
                                                    cb: (folder) => {
                                                        addModalType({
                                                            cls: "AlertCustom", arg: {
                                                                title: "移出此清單？",
                                                                desc: `將野放點移動至 ${folder.pocket_lists_name}。`,
                                                                options: [
                                                                    {
                                                                        label: "移動", cb: () => {
                                                                            console.log("folder",folder)
                                                                            selPot.forEach(v => {
                                                                                updatePocketlist("moveItem",arg.folder.pocket_lists_id,v.pocket_list_items_id,folder.pocket_lists_id);
                                                                                apiManager.fetchPut(`pocket-list/${arg.folder.pocket_lists_id}/items/${v.pocket_list_items_id}`, {pocket_list_items_mst:folder.pocket_lists_id});
                                                                            })
                                                                        }
                                                                    },
                                                                    {
                                                                        label: "取消", cb: () => {
                                                                        }
                                                                    },
                                                                ],
                                                            }
                                                        })
                                                    }
                                                }
                                            })
                                        }}>
                                            移動至
                                        </button>
                                    </div>
                                }

                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition >
        </div >
    );
}

export default memo(EditPotListAction);